import { LoanSummarySectionTypes } from '../../models/loan-summary-section-types.enum';

export abstract class LoanSummaryComponentActions {
  abstract getSectionType(): LoanSummarySectionTypes;

  abstract resetValidations(): void;

  /** [Optional]: In your implementation, call ChangeDetectorRef.detectChanges(). This will apply validation styling on FormControl(s) on Save. */
  abstract validate(): void;
}
